import React from 'react';

interface PostTagProps {
  children: React.ReactNode;
  color?: string;
  bgColor?: string;
  className?: string;
}

export const PostTag: React.FC<PostTagProps> = ({
  children,
  color = '#ffffff',
  bgColor = '',
  className = '',
}) => {
  return (
    <div
      className={`flex items-center text-28 sm:text-48 font-semibold p-[8px]text-[${color}] ${className}`}
      style={{
        backgroundColor: bgColor,
      }}
    >
      {children}
    </div>
  );
};

export default PostTag; 